import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';

type PromptLoginMode = 'login' | 'signup';

export async function promptLogin(flowAPI: ControllerFlowAPI, mode: PromptLoginMode = 'login'): Promise<boolean> {
  const { wixCodeApi } = flowAPI.controllerConfig;

  try {
    const user = await wixCodeApi.user.promptLogin({
      mode,
      modal: true,
    });

    return user.loggedIn;
  } catch {}

  return false;
}
